import React from 'react';
import PropTypes from 'prop-types';

const InfoIcon = ({ size = 18, color = '#585B5E' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 18 18" fill="none">
    <g>
      <path fill={color} d="M9,18c-5,0-9-4-9-9s4-9,9-9s9,4,9,9c0,0,0,0,0,0C18,14,14,18,9,18z M9,1.3C4.8,1.3,1.3,4.7,1.3,9c0,4.3,3.4,7.7,7.7,7.7s7.7-3.4,7.7-7.7c0,0,0,0,0,0C16.7,4.8,13.2,1.3,9,1.3z" />
      <circle fill={color} cx="9" cy="5.6" r="1.2" />
      <rect x="8.2" y="8.1" fill={color} width="1.6" height="5.3" />
    </g>
  </svg>
);

InfoIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

export default InfoIcon;
